import type { AssetWorkflowOptions } from '../../types';

export const addOriginWorkflow: AssetWorkflowOptions = {
  workflowKey: 'addOriginWorkflow',
  workflowType: 'addAssetWorkflow',
  assetType: 'origin',
  workflowIndex: 1,
  workflowConditionalMatcher: [
    {
      assetType: 'schedule',
      schema: {
        type: 'array',
        minItems: 1,
      },
    },
  ],
  workflowName: 'Add an Origin to your fulfillment network',
  workflowDescription: `In the Shipium System, an Origin represents a shipping source location. Select ‘Add Origin' to add a new origin to your configuration.`,
  workflowStepOptions: [
    {
      workflowStepKey: 'originType',
      workflowStepNavigationName: 'Origin Type',
      workflowComponent: {
        workflowComponentType: 'singleSelect',
        prompt: 'What type of Fulfillment Origin is this?',
        description: 'The origin type determines how this fulfillment node will behave.',
        help: '',
        options: [
          { optionText: 'Fulfillment Center', optionValue: 'fc' },
          { optionText: 'At Large', optionValue: 'at_large' },
          { optionText: 'Store', optionValue: 'store' },
        ],
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'originType',
      },
    },
    {
      workflowStepKey: 'partnerProvidedId',
      workflowStepNavigationName: 'Origin ID Alias',
      optional: true,
      workflowComponent: {
        workflowComponentType: 'textEntry',
        prompt: 'Enter a unique identifier for this origin',
        description: 'This is optional but will allow you to more easily reference this origin in API calls.',
        help: '',
      },
      includeInDefaultAssetNameRules: {
        includeInDefaultAssetName: true,
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'partnerProvidedId',
      },
    },
    {
      workflowStepKey: 'originName',
      workflowStepNavigationName: 'Origin Name',
      workflowComponent: {
        workflowComponentType: 'assetNameEntry',
        prompt: 'What should this Origin be named?',
        description: ``,
        help: '',
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'name',
      },
    },
    {
      workflowStepKey: 'originDescription',
      workflowStepNavigationName: 'Origin Description',
      optional: true,
      workflowComponent: {
        workflowComponentType: 'textEntry',
        rows: 10,
        prompt: 'Enter a description (optional):',
        description: ``,
        defaultValue: '',
        help: '',
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'description',
      },
    },
    {
      workflowStepKey: 'fulfillmentCenterAddress',
      workflowStepNavigationName: 'FC Address',
      excludeFromNavigation: false,
      refreshAssetsOnStepCompletion: true,
      workflowComponent: {
        workflowComponentType: 'addressEntry',
        prompt: 'What is the ship from address for this origin?',
        description: 'Shipium needs your FC addresses to set up your network',
        help: 'Enter your address to continue',
        options: [],
      },
      workflowStateToAssetMapping: {
        mappingType: 'link',
        linkAssetType: 'address',
      },
    },
    {
      workflowStepKey: 'fulfillmentCenterSchedule',
      workflowStepNavigationName: 'Schedule',
      excludeFromNavigation: false,
      workflowComponent: {
        workflowComponentType: 'scheduleSelect',
        prompt: 'Which schedule will be used for this fulfilment origin?',
        description: '',
        help: '',
        defaultValue: null,
        options: [],
      },
      workflowStateToAssetMapping: {
        mappingType: 'link',
        linkAssetType: 'schedule',
      },
    },
    {
      workflowStepKey: 'fulfillmentCenterContact',
      workflowStepNavigationName: 'FC Contact',
      excludeFromNavigation: false,
      workflowComponent: {
        workflowComponentType: 'contactEntry',
        prompt: 'Who is the contact for this origin?',
        description: 'Shipium needs your FC contact to set up your network',
        help: 'Enter your contact to continue',
        options: [],
      },
      workflowStateToAssetMapping: {
        mappingType: 'link',
        linkAssetType: 'contact',
      },
    },
    {
      workflowStepKey: 'tenantSelect',
      workflowStepNavigationName: 'Tenant Select',
      workflowComponent: {
        assetType: 'tenant',
        workflowComponentType: 'tenantSelect',
        prompt: 'Does this origin belong to a specific tenant?',
        description: '',
        help: 'Specifying a tenant will allow you to more easily filter you various configuration pieces',
      },
      workflowStepConditionalMatcher: [
        {
          assetType: 'tenant',
          schema: { type: 'array', minItems: 1 },
        },
      ],
      workflowStateToAssetMapping: {
        mappingType: 'link',
        linkAssetType: 'tenant',
        linkType: 'Tenant',
      },
      optional: true,
    },
    {
      workflowStepKey: 'summary',
      workflowStepNavigationName: 'Configuration Summary',
      workflowComponent: {
        workflowComponentType: 'workflowSummary',
        title: 'Add Origin Summary',
        description: 'The FC Origin will be created.  Please review your selections.',
        help: '',
      },
      workflowStateToAssetMapping: {
        mappingType: 'ignore',
      },
    },
  ],
};
